import { theme } from "@local-logic/core/ui";
import { styled } from "styled-components";

export const CategoryScores = styled.div`
  display: flex;
  overflow-x: scroll;
  padding: ${theme["--ll-spacing-x-small"]} ${theme["--ll-spacing-medium"]};
  flex-shrink: 0;
  position: relative;
`;

export const ScoreItem = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: none;
  border: none;
  min-width: 60px;
  padding: 0;
  margin: 0 8px;
  flex-shrink: 0;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const BadgeContainer = styled.div`
  position: absolute;
  top: -6px;
  right: 4px;
  border: 2px solid ${theme["--ll-color-background"]};
  border-radius: 6px;
`;

export const TextContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

export const LoadingItemContainer = styled.div`
  margin: 0 2px;
`;
